import { Button } from '../../components/Button';
import { HomeIcon, AccountIcon, BriefcaseIcon } from '../../icons/NavIcons';
import { Card, IconWrap, NavItem, SignOutWrapper, Title, Wrapper } from './AccountSideMenu.styles';
import type {
  AccountSideMenuIcon,
  AccountSideMenuItem,
  AccountSideMenuProps,
} from './AccountSideMenu.types';

const iconMap: Record<AccountSideMenuIcon, (props: { size?: number }) => JSX.Element> = {
  home: HomeIcon,
  profile: AccountIcon,
  bookings: BriefcaseIcon,
};

function renderItem(item: AccountSideMenuItem) {
  const Icon = iconMap[item.icon];
  return (
    <NavItem
      key={item.id}
      type="button"
      onClick={item.onClick}
      disabled={item.disabled}
      $active={item.active}
      $disabled={item.disabled}
      aria-current={item.active ? 'page' : undefined}
    >
      <IconWrap>
        <Icon size={18} />
      </IconWrap>
      {item.label}
    </NavItem>
  );
}

export function AccountSideMenu({
  title = 'Account',
  items,
  onSignOut,
  signOutLabel = 'Sign out',
  navigationLabel = 'Account navigation',
}: AccountSideMenuProps) {
  return (
    <Wrapper data-testid="account-side-menu">
      <Title>{title}</Title>
      <Card aria-label={navigationLabel}>{items.map(renderItem)}</Card>
      {onSignOut && (
        <SignOutWrapper>
          <Button type="button" variant="outline" size="medium" onClick={onSignOut}>
            {signOutLabel}
          </Button>
        </SignOutWrapper>
      )}
    </Wrapper>
  );
}
